import { differenceInMilliseconds, endOfDay, startOfToday } from 'date-fns';
import { useEffect, useState } from 'react';

const ONE_DAY = 24 * 60 * 60 * 1000;

/** Returns current start of day, refreshes daily */
export function useToday(): Date {
  const [today, setToday] = useState<Date>(() => startOfToday());

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;

    const timeUntilNextDay = differenceInMilliseconds(endOfDay(new Date()), new Date()) + 1;

    const timeoutId = setTimeout(() => {
      setToday(startOfToday());
      intervalId = setInterval(() => setToday(startOfToday()), ONE_DAY);
    }, timeUntilNextDay);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, []);

  return today;
}
